import { buildRootUrl } from '@/common/app/utils/urlsUtils';
import { getCommonPageMetaContent } from '../../app/pageUtils';
import { CommonPageType } from '../../domain/CommonPage.domain';
import { CommonMeta } from '@/common/ui/meta/CommonMeta';
import TravelerStories from '@/shared/images/HeroImages/TravelerStories.jpg';
import Blog from '@/shared/images/HeroImages/Blog.jpg';
import Partners from '@/shared/images/HeroImages/Partners.jpg';

type CommonPageMetaProps = {
    type: CommonPageType;
    title: string;
};

export const CommonPageMeta = ({ type, title }: CommonPageMetaProps) => {
    const targetUrl = `/${type}/`;
    const rootUrl = buildRootUrl(targetUrl);
    const content = getCommonPageMetaContent(type);
    const imageSrc =
        type === 'blog' ? Blog.src : type === 'partners' ? Partners.src : TravelerStories.src;

    return (
        <CommonMeta
            title={title}
            canonical={rootUrl}
            description={content}
            ogType="article"
            ogTitle={title}
            ogDescription={content}
            ogUrl={rootUrl}
            imageSrc={imageSrc}
            ogImageAlt={title}
            slug={''}
        />
    );
};
